import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { getMode } from '../lib/profiles';
import { isSprinkler, sprayShape, sprayR, useSprayOn } from '../lib/spray';

// garden: translucent throw circles / sectors around every sprinkler -> dry gaps are visible at once
export default function useSprayLayer(mapRef, fittings) {
  const on = useSprayOn(), ref = useRef(null);
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return undefined;
    ref.current?.remove();
    ref.current = null;
    if (!on || getMode() !== 'garden') return undefined;
    const list = (fittings || []).filter(isSprinkler);
    if (!list.length) return undefined;
    ref.current = L.layerGroup(list.map((f) => L.polygon(sprayShape(f), { pane: 'pits', color: '#0284c7', weight: 1, opacity: 0.8, fillColor: '#38bdf8', fillOpacity: 0.22, interactive: false, className: 'spray-shape' })
      .bindTooltip(`${f.name} · ${String(sprayR(f)).replace('.', ',')} m`, { sticky: true }))).addTo(map);
    return () => { ref.current?.remove(); ref.current = null; };
  }, [mapRef, fittings, on]);
}
